const overrides = {
    field: {
        ratingPlans: {
            partner: {
                MSA: {
                    states: ['NC']
                }
            },
        }
    }
};
export default overrides;
